export const GENERAL_PHONE = {
  display: "085 - 36 96 469",
  href: "tel:+31853696469",
  ariaLabel: "Bel studie connect op 085 - 36 96 469",
} as const;

export function trackPhoneClick(location: string) {
  const dataLayer = (
    window as Window & { dataLayer?: Array<Record<string, unknown>> }
  ).dataLayer;

  dataLayer?.push({
    event: "phone_click",
    phone_location: location,
  });
}